var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "modal", staticClass: "modal fade", attrs: { role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("dutyDisabled")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.disabled,
                    expression: "disabled"
                  }
                ],
                ref: "checkbox",
                staticClass: "form-check-input",
                attrs: { id: "cb_" + _vm._uid, type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.disabled)
                    ? _vm._i(_vm.disabled, null) > -1
                    : _vm.disabled
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.disabled,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.disabled = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.disabled = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.disabled = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "cb_" + _vm._uid }
                },
                [_vm._v(_vm._s(_vm.$t("dutyDisabled")))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("btnCancel")) +
                    "\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "createButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.save }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("btnSave")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }